var __jsx = React.createElement;
import React from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
var StatusBadge = function StatusBadge(_ref) {
  var currentStatus = _ref.currentStatus;
  var lang = useLang();
  var statusLabel = lang === "ar" ? currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.name_ar : currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.name_en;

  // Get status styling based on status id
  var getStatusStyling = function getStatusStyling() {
    var statusId = currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.id;
    switch (statusId) {
      case "under_inspection":
        //"بانتظار الفحص"
        return {
          bgColor: "bg-[#FEFAEA]",
          borderColor: "border-[#FEFAEA]",
          textColor: "text-[#AC8900]"
        };
      case "pending_booking":
        //انتظار حجز الموعد
        return {
          bgColor: "bg-[#F4EDFC]",
          borderColor: "border-[#F4EDFC]",
          textColor: "text-[#8E47E0]"
        };
      case "awaiting_offer_approval":
        //بإنتظار موافقتك
        return {
          bgColor: "bg-[#E7E7F8]",
          borderColor: "border-[#E7E7F8]",
          textColor: "text-[#0D0DB5]"
        };
      case "under_negotiation":
        ////"بمرحلة التفاوض"
        return {
          bgColor: "bg-[#FFF0F0]",
          borderColor: "border-[#FDEFEB]",
          textColor: "text-[#EC6234]"
        };
      case "purchased":
        //تم استكمال العملية
        return {
          bgColor: "bg-[#E6F7EF]",
          borderColor: "border-[#E6F7EF]",
          textColor: "text-[#00B362]"
        };
      default:
        return {
          bgColor: "bg-[#F5F5F5]",
          borderColor: "border-[#F5F5F5]",
          textColor: "text-[#666666]"
        };
    }
  };
  var statusStyling = getStatusStyling();
  return /*#__PURE__*/React.createElement("div", {
    id: "status-badge-".concat(currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.id),
    className: "".concat(statusStyling.bgColor, " border ").concat(statusStyling.borderColor, " rounded-full px-3 md:px-6 py-2 whitespace-nowrap max-[390px]:max-w-[120px] max-[390px]:whitespace-normal max-[390px]:text-center max-[390px]:px-2 max-[390px]:py-1")
  }, /*#__PURE__*/React.createElement("span", {
    id: "status-badge-text-".concat(currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.id),
    className: "".concat(statusStyling.textColor, " font-semibold text-xs md:text-base max-[390px]:text-[10px] max-[390px]:leading-tight")
  }, statusLabel));
};
export default StatusBadge;